<template>
  <transition name="fade">
    <div
      class="modal"
      v-if="isShowInsertVideo"
      style="z-index:100;"
    >
      <div
        class="container"
        v-loading='addLoading'
        element-loading-text="添加中，请稍后。。。"
      >
        <div class="upload_top msp_icon_close">
          <span style="float:left;">从素材库选择</span>
          <span
            class="iconfont el-icon-close"
            style="float:right;font-size:20px;cursor:pointer;line-height:44px;"
            @click.stop='closeInsertVideoBox()'
          ></span>
        </div>
        <div class="headimg_type">
          <el-tabs
            v-model="activeName"
            type="card"
            @tab-click="handleClick"
          >
            <el-tab-pane
              label="图片"
              name="picture"
            >图片</el-tab-pane>
            <el-tab-pane
              label="视频"
              name="video"
            >视频</el-tab-pane>
            <el-tab-pane
              label="音频"
              name="audio"
            >音频</el-tab-pane>
            <el-tab-pane
              label="附件"
              name="file"
            >附件</el-tab-pane>
          </el-tabs>
        </div>

        <div class="insert_video">
          <div class="insert_video_repo">
            <repotree
              @folderClick='handleNodeClick'
              :isHidePersonRepo='true'
            ></repotree>
          </div>
          <div
            class="nodata_pic"
            v-show='videoList.length==0'
          >
            <img
              src="../../../static/img/nodata.png"
              alt=""
            />
            <div>空空如也。。。</div>
          </div>
          <div
            class="insert_video_list"
            v-loading='videoloading'
            element-loading-text="拼命加载中"
          >
            <el-scrollbar
              class="insert_material_video"
              v-show='videoList.length>0'
            >
              <ul
                v-show="activeName === 'video' || activeName === 'picture'"
                class="video_picture"
              >
                <li
                  v-for="(item,index) in videoList"
                  @click.stop='lookinfoVideo(item)'
                >
                  <img
                    :src="item.cover_img"
                    alt=""
                    class="video_coverimg"
                    v-if="item.cover_img"
                  >
                  <img
                    src="../../../static/img/media.png"
                    alt=""
                    v-if='!item.cover_img && activeName === "video"'
                  >
                  <img
                    v-show="activeName === 'video'"
                    src="../../../static/img/videoplay.png"
                    alt=""
                    class="video_playimg"
                    style="cursor:pointer;"
                  >

                  <div
                    class="video_each_status"
                    v-show="activeName === 'video'"
                  >
                    <div class="each_status">
                      <span
                        v-if="item.flag_sign_and_issue"
                        class="yes"
                      >已签发</span>
                      <span
                        v-if="!item.flag_sign_and_issue"
                        class="unAudit"
                      >未签发</span>
                    </div>
                    <div class="each_status">
                      <span
                        v-if="item.flag_push === 'yes'"
                        class="yes"
                      >已推送</span>
                      <span
                        v-if="item.flag_push === 'no'"
                        class="unAudit"
                      >未推送</span>
                    </div>
                    <div class="each_status">
                      <span
                        v-if="item.audit_status === 'yes'"
                        class="yes"
                      >已通过</span>
                      <span
                        v-if="item.audit_status === 'no'"
                        class="no"
                      >未通过</span>
                      <span
                        v-if="item.audit_status === 'doing'"
                        class="doing"
                      >审核中</span>

                      <span
                        v-if="item.audit_status === 'unAudit'"
                        class="unAudit"
                      >未审核</span>
                    </div>
                  </div>

                  <div
                    class="choice_current_video"
                    :class='[isCurrentChoice(item.id) ? "choice_current_videoActive" : ""]'
                    @click.stop='choiceCurrenInsertVideo(item.id)'
                  >
                    <span class="el-icon-check"></span>
                  </div>

                  <div
                    class="video_title"
                    :title="item.title"
                  >
                    <span>{{item.title}}</span>
                  </div>

                </li>
              </ul>
              <ul
                v-show="activeName === 'file' || activeName === 'audio'"
                class="materialaudio_list"
              >
                <li v-for='(item,index) in videoList'>
                  <div
                    class="material_audio_name"
                    style="flex:1;"
                  >
                    <div @click.stop='choiceCurrenInsertVideo(item.id)'>
                      <img
                        v-if="isCurrentChoice(item.id)"
                        src="../../../static/img/clickchoice.png"
                        alt=""
                        style="width:16px;height:16px;"
                      >
                      <img
                        v-if="!isCurrentChoice(item.id)"
                        src="../../../static/img/nochoice.png"
                        alt=""
                        style="width:16px;height:16px;"
                      >
                    </div>
                    <img
                      v-if="activeName === 'audio'"
                      src="../../../static/img/audio.png"
                      alt=""
                    />
                    <img
                      v-if="activeName === 'file'"
                      src="../../../static/img/file_img.png"
                      alt=""
                    />
                    <span class="audio_file_name">{{item.file_name}}</span>
                    <div
                      class="operate_audio"
                      v-if="activeName === 'audio'"
                    >
                      <span
                        class="iconfont icon-yulan1"
                        title="预览"
                        @click.stop='lookinfoVideo(item)'
                      ></span>
                    </div>
                  </div>
                </li>
              </ul>
            </el-scrollbar>
          </div>
        </div>
        <div class="page_pagenation">
          <el-pagination
            :current-page.sync="currentPage"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next, jumper"
            :total="videoAllTotal"
          >
          </el-pagination>
        </div>
        <div class="sure_btn">
          <el-button
            type="primary"
            @click.native='choiceVideoIssueUrl()'
          >确定</el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as api from '../../../api'
import repotree from '../repotree/repotree'
import logsMixins from '../../../mixins/logs'
import Vue from 'vue'
export default {
  components: {
    repotree
  },
  mounted () {
    this.$root.eventHub.$on('relatedMatterFromMaterial', (data) => {
      this.isShowInsertVideo = true
      this.articleId = data
    })
  },
  destroyed () {
    this.$root.eventHub.$off('relatedMatterFromMaterial')
  },
  mixins: [logsMixins],
  data () {
    return {
      videoList: [],
      currentFolder: '',
      videoAllTotal: 0,
      currentPage: 1,
      currentInsertVideo: [],
      isShowInsertVideo: false,
      videoloading: false,
      activeName: 'picture',
      pageSize: 10,
      articleId: '',
      addLoading: false

    }
  },
  computed: {
    isCurrentChoice () {
      return function (item) {
        if (this.currentInsertVideo.length > 0) {
          var k = 0
          for (var i = 0; i < this.currentInsertVideo.length; i++) {
            if (this.currentInsertVideo[i] !== item) {
              k++
            } else {
              break;
            }
          }
          if (k == this.currentInsertVideo.length) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      }
    }
  },
  methods: {
    closeInsertVideoBox () {
      this.isShowInsertVideo = false
    },
    handleNodeClick (data) {
      this.currentFolder = data
      if (!data.flag_repo) {
        this.currentPage = 1
        this.getVideoList(0, data)
      }
    },
    getVideoList (pagenow, data) {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                       // 必须字段： 创建文章参数
          'sortTime': 'time_update', // 排序时间（创建时间：time_create | 更新时间:time_update）
          'sortRule': 'desc', // 排序规则（正序:asc | 倒叙: desc）
          'definition': '', // 清晰度（高清:high|标清:standard）
          'composition': 'all', // 构图（全部:all/横图:heng/竖图:shu/方图:fang）
          'widthAndHigh': 0,
          'width': 0,
          'height': 0,
          'format': '',
          'startSize': '',
          'endSize': '',
          'flag_issue': 'all', // 签发状态 全部：all  已签：yes，未签：no
          'flag_push': 'all', // 推送状态： 全部：all  已推送：yes  未推送：no
          'flag_audit': 'all', // 审核状态： 全部：all  已审核：yes  未审核：no  审核中： doing
          'folderId': data.id,
          'type': this.activeName, // 素材类型：图片 picture 视频 video 音频 audio  附件 file
          'tags': [], // 标签
          'searchValue': '',
          'searchType': 'all',
          'pageSize': this.pageSize,
          'pageNum': pagenow,
          'startTime': '',
          'endTime': ''
        }
      }
      this.videoloading = true
      this.currentPage = pagenow + 1
      var apitye = ''
      if (this.activeName === 'picture' || this.activeName === 'file') {
        apitye = _IMGFILEURL_
      } else if (this.activeName === 'video' || this.activeName === 'audio') {
        apitye = _VIDEOAUDIOURL_
      }
      this.videoList = []
      api._post(apitye + 'public/pageQuery', option).then((res) => {
        if (res.code == 200) {
          try {
            this.videoAllTotal = res.data.totalElements
            this.videoList = res.data.content
          } catch (e) {
            this.videoAllTotal = 0
            this.videoList = []
          }
        } else {
          this.videoAllTotal = 0
          this.videoList = []
        }
        this.videoloading = false
      }).catch((error) => {
        console.log(error)
        this.videoloading = false
      })

    },
    handleCurrentChange (page) {
      if (!(this.currentFolder.flag_repo)) {
        this.getVideoList(page - 1, this.currentFolder)
      }
    },
    choiceCurrenInsertVideo (item) {
      if (item) {
        if (this.currentInsertVideo.length > 0) {
          var k = 0
          for (var i = 0; i < this.currentInsertVideo.length; i++) {
            if (this.currentInsertVideo[i] !== item) {
              k++
            } else {
              break;
            }
          }
          if (k == this.currentInsertVideo.length) {
            this.currentInsertVideo.push(item)
          }
          else {
            for (var j = 0; j < this.currentInsertVideo.length; j++) {
              if (this.currentInsertVideo[j] == item) {
                this.currentInsertVideo.splice(j, 1)
              }
            }
          }
        } else {
          this.currentInsertVideo.push(item)
        }
      }
    },
    choiceVideoIssueUrl () {
      var url = _IMGFILEURL_ + 'public/addArticle_m'
      var option = {
        ...this.$store.getters.baseOption,
        params: {
          articleId: this.articleId.id,
          materialIds: this.currentInsertVideo
        }
      }
      if (this.currentInsertVideo.length > 0) {
        this.addLoading = true
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.$notify.success({
              title: '成功',
              message: '添加成功'
            })
            this.getRelatedMatters(this.articleId.id)
            this.$root.eventHub.$emit('setRelateMatterFlag', this.articleId.id, true)

            this.$set(this.articleId, 'flag_material', true)
            if (this.$route.path === "/editorArticle" || this.$route.path === "/atlasmanuscript") {
              try {
                window.opener.postMessage(this.articleId, '*')
              } catch (error) {
                console.log(error)
              }
            }

            this.isShowInsertVideo = false
          }
          this.addLoading = false
        }).catch((error) => {
          console.log(error)
          this.addLoading = false
        })
      } else {
        this.$notify.warning({
          title: '警告',
          message: '请至少选择一个素材'
        })
      }
    },
    lookinfoVideo (item) {
      if (item.type === 'video') {
        this.$root.eventHub.$emit('getMatterDetail', item, 'videoDetail')
      } else if (item.type === 'audio') {
        this.$root.eventHub.$emit('getMatterDetail', item, 'audioDetail')
      }
      else if (item.type === 'picture') {
        this.$root.eventHub.$emit('getMatterDetail', item, 'imgDetail')
      }
    },
    handleClick (tab, event) {
      if (this.currentFolder) {
        if (!(this.currentFolder.flag_repo)) {
          this.getVideoList(0, this.currentFolder)
        }
      }
    },
  },
  watch: {
    isShowInsertVideo () {
      if (this.isShowInsertVideo == false) {
        this.currentInsertVideo = []
        this.videoList = []
        this.currentFolder = ''
        this.videoAllTotal = 0
        this.currentPage = 1
        this.activeName = 'picture'
        this.articleId = ''
      }
    }
  }
}
</script>
<style scoped>
.container {
  transition: all 1s ease;
  width: 60%;
  height: 80%;
  background-color: #ffffff;
  box-shadow: 0px 0px 5px #999;
  border-radius: 5px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.upload_top {
  width: 100%;
  height: 44px;
  line-height: 44px;
  background: #f7faff;
  border-bottom: 1px solid #c0beff;
  clear: both;
  padding: 0 20px 0 20px;
  box-sizing: border-box;
}
.upload_top span {
  color: #333333;
  font-size: 14px;
}

.headimg_type {
  height: 38px;
  border-top: 1px solid #e6e7eb;
  background: #f0f1f3;
}

.insert_video {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  height: calc(100% - 84px);
}
.insert_video_repo {
  width: 274px;
  height: 100%;
  box-sizing: border-box;
  border-right: 1px solid #e8e8e8;
}
.insert_video_list {
  flex: 1;
  height: 100%;
  position: relative;
  padding-top: 20px;
  box-sizing: border-box;
}
.page_pagenation {
  position: absolute;
  bottom: 20px;
  left: 290px;
}
.insert_material_video {
  height: 88%;
}
.insert_material_video .video_picture {
  width: 100%;
  height: 100%;
  clear: both;
}
.insert_material_video .video_picture li {
  width: 254px;
  height: 220px;
  float: left;
  margin-left: 20px;
  margin-bottom: 50px;
  background: #424242;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.insert_material_video .video_picture li .video_coverimg {
  display: block;
  max-width: 254px;
  max-height: 220px;
}
.insert_material_video .video_picture li .video_playimg {
  position: absolute;
  left: 87px;
  top: 70px;
}
.insert_material_video .video_picture li .video_each_status {
  position: absolute;
  right: 0;
  top: 0;
}
.insert_material_video .video_picture li .video_each_status .each_status {
  margin-bottom: 4px;
}

.insert_material_video .video_picture li .video_each_status .each_status span {
  display: inline-block;
  padding: 5px 10px;
  color: #fff;
  font-size: 14px;
}

.insert_material_video .video_picture li .video_each_status .each_status .yes {
  background: #6bd57c;
}

.insert_material_video .video_picture li .video_each_status .each_status .no {
  background: #f56969;
}

.insert_material_video
  .video_picture
  li
  .video_each_status
  .each_status
  .doing {
  background: #ffad2f;
}

.insert_material_video
  .video_picture
  li
  .video_each_status
  .each_status
  .unAudit {
  background: #aaa;
}

.insert_material_video ul li .video_title {
  position: absolute;
  bottom: -20px;
  left: 0;
  width: 100%;
  color: #303133;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  text-align: center;
}

.choice_current_video {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 0;
  top: 0;
  background: #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #688eff;
}

.choice_current_video span {
  color: #fff;
  font-size: 12px;
  display: none;
}
.choice_current_videoActive {
  background: #688eff;
}
.choice_current_videoActive span {
  display: block;
}
.sure_btn {
  clear: both;
  position: absolute;
  bottom: 20px;
  right: 20px;
  box-sizing: border-box;
}
.sure_btn button {
  width: 74px;
  height: 32px;
  padding: 0px;
  line-height: 32px;
  text-align: center;
}
.nodata_pic {
  position: absolute;
  left: 56%;
  top: 40%;
}
.nodata_pic div {
  color: #333;
  font-size: 20px;
  padding-left: 20px;
  box-sizing: border-box;
}
.matter_local {
  width: 100%;
  height: 90%;
  display: flex;
  justify-content: center;
  padding-top: 10px;
  overflow: auto;
}

.upload_matter_button,
.save_matter {
  display: flex;
  padding: 14px 0 20px 76px;
}

.upload_matter_button button {
  margin-right: 10px;
  padding: 0;
  width: 110px;
  height: 38px;
}

.upload_matter_button span {
  display: inline-block;
  overflow: hidden;
  width: 300px;
  color: #606266;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 38px;
}

.materialaudio_list {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
}

.materialaudio_list li {
  width: 100%;
  height: 60px;
  display: flex;
  border-bottom: 1px solid #d8d8d8;
  cursor: pointer;
  padding-right: 20px;
  box-sizing: border-box;
}

.material_audio_name {
  height: 60px;
  display: flex;
  clear: both;
  align-items: center;
  position: relative;
}

.material_audio_size {
  justify-content: center;
}
.material_audio_name span {
  color: #333333;
  font-size: 14px;
}
.material_audio_name img {
  display: block;
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.materialaudio_list li:hover {
  background-color: rgba(246, 250, 255, 1);
}
.materialaudio_list .audio_file_name {
  display: inline-block;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.operate_audio {
  height: 60px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  display: none;
  align-items: center;
}

.operate_audio .iconfont {
  color: #b5b8d9;
  font-size: 18px;
  cursor: pointer;
  margin-left: 20px;
  box-sizing: border-box;
}

.materialaudio_list li:hover .operate_audio {
  display: flex;
}
</style>
